/**
 * PRAT-201 — instalar o app no Android: o Chrome avisa (`beforeinstallprompt`)
 * que o site pode ir para a tela inicial; guardamos o evento e mostramos o
 * botão "Instalar o app" no convite de avisos. O evento chega cedo, por isso
 * `listenInstallPrompt()` roda no main.tsx, antes de qualquer tela.
 */
type InstallEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

let deferred: InstallEvent | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach(fn => fn());

export function listenInstallPrompt(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', e => {
    e.preventDefault(); // nada de mini-barra do Chrome: o convite é nosso
    deferred = e as InstallEvent;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    notify();
  });
}

export function canInstall(): boolean {
  return deferred !== null;
}

/** Abre a janela do Chrome. true = instalou. */
export async function promptInstall(): Promise<boolean> {
  const ev = deferred;
  if (!ev) return false;
  deferred = null;
  notify();
  await ev.prompt();
  const choice = await ev.userChoice.catch(() => ({ outcome: 'dismissed' as const }));
  return choice.outcome === 'accepted';
}

export function onInstallChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Só para os testes. */
export function __setInstallEvent(ev: InstallEvent | null): void {
  deferred = ev;
  notify();
}
